var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconoPendol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.86 100.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.43,0A50.48,50.48,0,0,0,0,50.43c0,1.56.08,3.11.22,4.64L13.34,39.56A38.66,38.66,0,0,1,89.09,50.43a39.17,39.17,0,0,1-.42,5.66,9,9,0,0,0-1.47-.86L82.63,53.1l-12.69-18L58,34.2l-8.5,8.45L46.21,38l-7.9-1.82L25.05,46.73l-2.22,5.61-4.75,1.75L5.6,68.83,4.18,70.51A50.39,50.39,0,0,0,83.36,88.6l-7.92-8.72A38.59,38.59,0,0,1,19.08,73l6.7-7.91,7-2.57,3.09-7.79,4-3.18,4.76,6.78,9.64-2.11,8.62-8.57L74,63.42l7,3.29,2.82,3.11h0l8.21,9A50.41,50.41,0,0,0,50.43,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconoPendol);
export default __webpack_public_path__ + "static/media/logo-icono-pendol.02a9a8ac285458938f070c0a405fec02.svg";
export { ForwardRef as ReactComponent };